import { render, staticRenderFns } from "./MyPools.vue?vue&type=template&id=dc9d79ca&"
import script from "./MyPools.vue?vue&type=script&lang=js&"
export * from "./MyPools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports